module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002-br.88856a0.webp";